import React from 'react'

import { Donations } from './Donations'

export default function DonationsWrapper() {
  return (
    <section className="max-width-wrapper donations-wrapper">
      <header className="section-header">
        <div className="section-heading section-heading--secondary">
          <h1>Donations</h1>
        </div>
        <p className="section-header-desc">
          Mandatory contributions tied to specific sections. Triggered
          automatically when a fan has tickets in those sections.
        </p>
      </header>
      <Donations />
    </section>
  )
}
